export const en = {
    no_participants: 'No participants',
    go_to_staff: 'Go to Staff',
};
